<template>
  <div
    class="d-flex justify-content-center"
    :class="`sumo-bg-${bannerDetails.bg_color}`"
  >
    <DealBannerContent :banner-details="bannerDetails" tooltip-id="mobile-deal-banner-tooltip" />
  </div>
</template>

<script>
import DealBannerContent from './DealBannerContent.vue';

export default {
  name: 'MobileDealBannerHeader',
  components: {
    DealBannerContent,
  },
  props: {
    bannerDetails: {
      type: Object,
      required: true,
    },
  },
};
</script>
